<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-s-order"></i> 权限列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_box">
      <!-- 表格盒子 -->
      <div class="table_box">
        <!--表格-->
        <div class="table_box_main">
          <el-table :data="tableDataEnd" @sort-change="onSortChange">

            <el-table-column label="序号" align="center" type="index" width="80"></el-table-column>

            <el-table-column label="名称" align="center" sortable="custom" :sort-orders="['ascending','descending']"
              min-width="160" prop="name"></el-table-column>

            <el-table-column label="路径" align="left" sortable="custom" :sort-orders="['ascending','descending']"
              min-width="160" prop="path"></el-table-column>

            <el-table-column label="等级" align="center" sortable="custom" :sort-orders="['ascending','descending']"
              min-width="160" prop="class">

              <template slot-scope="row">
                <el-button size="mini" icon="el-icon-medal" type='primary' plain
                  v-if="row.row.class=='一级'">{{ row.row.class }}</el-button>
                <el-button size="mini" icon="el-icon-medal" type='success' plain
                  v-if="row.row.class=='二级'">{{ row.row.class }}</el-button>
                <el-button size="mini" icon="el-icon-medal" type='warning' plain
                  v-if="row.row.class=='三级'">{{ row.row.class }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页栏 -->
        <div class="pagination_box">

          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[4, 8, 12]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="totalItems">
          </el-pagination>
          
        </div>
      </div>
      <!-- 树形盒子 -->
      <div class="tree_box">
        <!-- 搜索 -->
        <div class="search_box">
          <el-input v-model="searchKey" clearable size="mini" placeholder="输入关键字搜索"
            @change="searchKeyChange(tableData,searchKey)">
            <el-button slot="append" icon="el-icon-search" @click="searchKeyChange(tableData,searchKey)"></el-button>
          </el-input>
        </div>
        <!--树形-->
        <div class="tree_box_main">
          <el-tree :data="treeData" :props="treeDefaultProps" ref="tree" :filter-node-method="filterNode"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'administrators',
    data() {
      return {
        // 表格************************************************************************
        // 表格总数居
        tableData: [{
            id: 1,
            name: "学生管理",
            path: "/",
            class: 0
          },
          {
            id: 2,
            name: "学生列表",
            path: "学生管理 /",
            class: 1
          },
          {
            id: 3,
            name: "查看学生列表",
            path: "学生管理 / 学生列表 /",
            class: 2
          },
          {
            id: 4,
            name: "编辑学生列表",
            path: "学生管理 / 学生列表 /",
            class: 2
          },
          {
            id: 5,
            name: "权限列表",
            path: "学生管理 /",
            class: 1
          },
          {
            id: 6,
            name: "查看权限列表",
            path: "学生管理 / 权限列表 /",
            class: 2
          },
          {
            id: 7,
            name: "学院列表",
            path: "学生管理 /",
            class: 1
          },
          {
            id: 8,
            name: "查看学院列表",
            path: "学生管理 / 学院列表 /",
            class: 2
          },
          {
            id: 8,
            name: "编辑学院列表",
            path: "学生管理 / 学院列表 /",
            class: 2
          },
        ],
        // 表格可检索内容 用于检索
        tableDataForm: {
          name: "",
          path: "",
          class: ""
        },
        // 搜索************************************************************************
        // 搜索关键字
        searchKey: "",
        // 搜索结果
        searchResult: [],
        // 分页***********************************************************************
        // 采集设备表格前页数据
        tableDataEnd: [],
        // 当前页数
        currentPage: 1,
        // 表格展示的行数
        pageSize: 8,
        // 总行数
        totalItems: 0,
        // 当前行
        currentRow: 0,
        // 当前表格排序
        currentSort: null,
        // 树形***********************************************************************
        // 树形数据
        treeData: [{
          id: 1,
          name: "学生管理",
          path: "/",
          class: 0,
          children: [{
              id: 2,
              name: "学生列表",
              path: "学生管理 /",
              class: 1,
              children: [{
                  id: 3,
                  name: "查看学生列表",
                  path: "学生管理 / 学生列表 /",
                  class: 2
                },
                {
                  id: 4,
                  name: "编辑学生列表",
                  path: "学生管理 / 学生列表 /",
                  class: 2
                },
              ]
            },
            {
              id: 5,
              name: "权限列表",
              path: "学生管理 /",
              class: 1,
              children: [{
                id: 6,
                name: "查看权限列表",
                path: "学生管理 / 权限列表 /",
                class: 2
              }, ]
            },
            {
              id: 7,
              name: "学院列表",
              path: "学生管理 /",
              class: 1,
              children: [{
                  id: 8,
                  name: "查看学院列表",
                  path: "学生管理 / 学院列表 /",
                  class: 2
                },
                {
                  id: 9,
                  name: "编辑学院列表",
                  path: "学生管理 / 学院列表 /",
                  class: 2
                },
              ]
            },
          ]
        }, ],
        // 树形配置
        treeDefaultProps: {
          children: 'children',
          label: 'name'
        },
      };
    },
    created() {
      // 请求表格数据
      this.getTableData()
    },
    mounted() {


    },
    methods: {
      // *********************************************************************************************************
      // 表格数据获取
      // *********************************************************************************************************
      // 请求表格数据 falg为是否还原表格状态
      getTableData(flag) {
        // TODO 获取表格数据
        for (let i = 0; i < this.tableData.length; i++) {
          switch (this.tableData[i].class) {
            case 0:
              this.tableData[i].class = "一级"
              break;
            case 1:
              this.tableData[i].class = "二级"
              break;
            case 2:
              this.tableData[i].class = "三级"
              break;
          }
        }
        this.totalItems = this.tableData.length
        this.handleCurrentChange(1)
      },
      // *********************************************************************************************************
      // 表格排序功能
      // *********************************************************************************************************
      // 表头某列点击排序
      onSortChange({
        prop,
        order
      }) {
        this.currentSort = {
          prop,
          order
        }
        if (this.searchKey === "") {
          this.tableData.sort(this.compare(prop, order));
        } else {
          this.searchResult.sort(this.compare(prop, order));
        }
        this.handleCurrentChange(this.currentPage)
      },
      // 排序比较
      compare(propertyName, sort) {
        return function(obj1, obj2) {
          var value1 = obj1[propertyName]
          var value2 = obj2[propertyName]
          if (typeof value1 === 'string' && typeof value2 === 'string') {
            const res = value1.localeCompare(value2, 'zh')
            return sort === 'ascending' ? res : -res
          } else {
            if (value1 <= value2) {
              return sort === 'ascending' ? -1 : 1
            } else if (value1 > value2) {
              return sort === 'ascending' ? 1 : -1
            }
          }
        }
      },
      // *********************************************************************************************************
      // 表格搜索功能
      // *********************************************************************************************************
      // 关键字变化或输入框失焦后的操作
      searchKeyChange(tableData, key) {
        if (key !== "") {
          this.searchResult = tableData.filter((obj) => this.searchCheck(obj, this.tableDataForm))
          this.totalItems = this.searchResult.length
        } else {
          this.totalItems = this.tableData.length
        }
        this.$refs.tree.filter(key);
        this.handleCurrentChange(1)
      },
      // 判断对象中是否包含搜索关键字 返回布尔值
      searchCheck(obj, form) {
        var flag = false
        for (let i = 0; i < Object.getOwnPropertyNames(obj).length - 1; i++) {
          // 获取对象的第i个key值
          var originalKey = Object.getOwnPropertyNames(obj)[i]
          for (let j = 0; j < Object.getOwnPropertyNames(form).length - 1; j++) {
            // 获取表格样式的第j个key值
            var targetKey = Object.getOwnPropertyNames(form)[j]
            // 如果key值匹配 则进行搜索
            if (originalKey === targetKey) {
              var value = Object.values(obj)[i]
              // 判断是否是数组
              if (Array.isArray(value)) {
                // 如果是数组 则遍历数组中的元素 调用searchCheck返回布尔值
                for (let k = 0; k < value.length; k++) {
                  flag = flag || this.searchCheck(value[k], Object.values(form)[j][0])
                }
                break
              }
              // 判断是否是对象
              else if (Object.prototype.toString.call(value) === '[object Object]') {
                // 如果是对象 则遍历对象元素 调用searchCheck返回布尔值
                flag = flag || this.searchCheck(value[k], Object.values(form)[j])
                break
              }
              // 判断是否是数字
              else if (typeof(Object.values(obj)[i]) === "number") {
                value = Object.values(obj)[i].toString()
              }
              // 判断是否是字符串
              else if (typeof(Object.values(obj)[i]) === "string") {
                value = Object.values(obj)[i]
              } else {
                break;
              }
              // 判断是否和关键词匹配
              flag = flag || value.toLowerCase().includes(this.searchKey.toLowerCase())
            }
          }
        }
        return flag
      },
      // *********************************************************************************************************
      // 分页功能
      // *********************************************************************************************************
      //监控当前页码 页码变化后 重新选取当前页的数据
      currentChangePage(list) {
        // from：当前页的第一行数据在list中的序号  to：下一页的第一行数据在list中的序号
        let from = (this.currentPage - 1) * this.pageSize;
        let to = this.currentPage * this.pageSize;
        this.tableDataEnd = [];
        for (; from < to; from++) {
          if (list[from]) {
            this.tableDataEnd.push(list[from]);
          }
        }
      },
      //每页展示的行数变化后的操作
      handleSizeChange(val) {
        this.pageSize = val;
        this.handleCurrentChange(1);
      },
      //页码变化后的操作
      handleCurrentChange(val) {
        this.currentPage = val;
        // 判断是否在搜索
        if (this.searchKey === "") {
          this.currentChangePage(this.tableData);
        } else {
          this.currentChangePage(this.searchResult);
        }
      },
      // *********************************************************************************************************
      // 树形搜索
      // *********************************************************************************************************
      // 树形搜索
      filterNode(value, data) {
        console.log(value, data);
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      }
    }
  };
</script>

<style lang="less" scoped>
  .main_box {
    width: 100%;

  }

  .tree_box {
    display: inline-block;
    vertical-align: top;
    width: 260px;
    border-radius: 8px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);

    .search_box {
      width: 220px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #fff;
      padding: 10px 20px 10px 20px;
      border-bottom: 1px solid #E9EEF7;
      border-radius: 8px 8px 0px 0px;
      vertical-align: middle;

      .el-input {
        width: 220px;
      }

      .el-input .el-button {
        width: 40px;
        padding: 0;
      }
    }

    .tree_box_main {
      width: 220px;
      height: 472px;
      padding: 10px 20px 10px 20px;
      border-radius: 0px 0px 8px 8px;
      background-color: #fff;
    }
  }

  .table_box {
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 270px);
    margin-right: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);

    .table_box_main {
      background-color: #fff;
      padding: 10px 20px 10px 20px;
      border-radius: 8px 8px 0px 0px;

      .el-button {
        font-size: 14px;
        cursor: auto;
      }

      .el-button--primary.is-plain:focus,
      .el-button--primary.is-plain:hover {
        color: #409EFF;
        border-color: #b3d8ff;
        background-color: #ecf5ff;
      }

      .el-button--success.is-plain:focus,
      .el-button--success.is-plain:hover {
        color: #67C23A;
        border-color: #c2e7b0;
        background-color: #f0f9eb;
      }

      .el-button--warning.is-plain:focus,
      .el-button--warning.is-plain:hover {
        color: #E6A23C;
        border-color: #f5dab1;
        background-color: #fdf6ec;
      }

      /deep/ .el-table__header tr th.el-table__cell {
        color: #515a6e;
        background-color: #f8f8f9;
        padding: 8px 0;

        .cell {
          height: 34px;
          line-height: 34px;
        }
      }
    }

    .pagination_box {
      padding: 0px 20px 10px 20px;
      text-align: center;
      background-color: #fff;
      border-radius: 0px 0px 8px 8px;
    }
  }
</style>
